import Range, { monthsArray } from 'v3/components/Range';
import Button from 'v3/components/Button';
import { Tooltip } from 'antd';
import { ErrorWarning } from '@styled-icons/remix-line/ErrorWarning';
import currency from 'currency.js';
import { Link } from 'react-router-dom';

import * as S from './styles';

export type DealBoxTypes = {
  save?: number;
  monthlyPayment: number;
  halfPayment?: number;
  loanAmount: number;
  tooltip: string;
  improveChances: () => void;
  pricingDetails: () => void;
  cfLink: string | undefined;
  firstValue: number;
  lastValue: number;
  terms: keyof typeof monthsArray;
  border?: boolean;
  dealType?: 'auto' | 'realEstate';
};

const DealBox = ({
  save = 0,
  monthlyPayment,
  halfPayment,
  loanAmount,
  tooltip,
  improveChances,
  pricingDetails,
  cfLink,
  firstValue,
  lastValue,
  terms,
  border = false,
  dealType = 'auto',
}: DealBoxTypes) => (
  <S.Wrapper border={border}>
    <S.AmountSection>
      <S.MonthlySection>
        <S.Text size="small">
          {halfPayment ? <strong>Before Credit Voucher</strong> : 'Starting at'}
        </S.Text>
        <S.MonthlyPayment>
          <strong>{currency(halfPayment ?? monthlyPayment).format()}</strong>/mo
        </S.MonthlyPayment>
        {halfPayment && (
          <>
            <S.Text size="small">
              <strong>After Credit Voucher</strong>
            </S.Text>
            <S.Text size="small">
              <strong>{currency(monthlyPayment).format()}/mo</strong>
            </S.Text>
          </>
        )}
        {save > 0 && <S.Tag>Save {currency(save).format()}</S.Tag>}
      </S.MonthlySection>
      <S.LoanSection>
        <S.Text size="default">Loan Amount</S.Text>
        <S.LoanAmount>
          {currency(loanAmount, { precision: 0 }).format()}
        </S.LoanAmount>
      </S.LoanSection>
    </S.AmountSection>
    <S.RangeSection>
      <S.ChanceText>
        <S.Text size="default">
          <strong>80% chance</strong> to get a{' '}
          {dealType === 'auto' ? 'car' : 'home'} between months{' '}
          {/* <Tooltip title={tooltip}>
            <S.IconWrapper>
              <ErrorWarning size={24} />
            </S.IconWrapper>
          </Tooltip> */}
        </S.Text>
      </S.ChanceText>
      <S.RangeRow>
        <Range
          months={terms}
          initialValue={firstValue}
          finalValue={lastValue}
        />
      </S.RangeRow>
      {/* <Button variant="anchor" size="small" onClick={improveChances}>
        Improve your chances
      </Button> */}
    </S.RangeSection>
    <S.ButtonSection>
      <Button variant="text" size="medium" onClick={pricingDetails}>
        Pricing Details
      </Button>
      <Button
        as={(props) => <Link to={cfLink} {...props} />}
        variant="brandPrimary"
        size="medium"
      >
        Get your terms
      </Button>
    </S.ButtonSection>
  </S.Wrapper>
);

export default DealBox;
